import { render, staticRenderFns } from "./FilterProduct.vue?vue&type=template&id=afe1335e&scoped=true"
import script from "./FilterProduct.vue?vue&type=script&lang=js"
export * from "./FilterProduct.vue?vue&type=script&lang=js"
import style0 from "./FilterProduct.vue?vue&type=style&index=0&id=afe1335e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe1335e",
  null
  
)

export default component.exports